module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/GMZgjR/images/e9781439629666_cover.jpg?1684229397535",
      "alt": "This image is the cover for the book Walker County, Alabama, Postcard History Series"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Walker County, Alabama, Postcard History Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Walker County is a unique place inhabited by a unique people. Characters including George \"Goober\" Lindsey, Tallulah Bankhead, Sybil Gibson, and Eric \"Butterbean\" Esch, and communities including Cordova, Carbon Hill, and Day's Gap and Horse Creek-or as we know them today, Oakman and Dora-have all contributed to the county's rich history. In this volume of vintage postcard images, readers will learn how the town of Jasper avoided extinction, visit the old Walker County Courthouse that burned six times, and discover which town in Walker County began as Bald Eagle.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pat Morrison\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Author and retired Walker County educator Pat Morrison has compiled an engaging collection of postcards and supplemented them with historic photographs to tell the story of this sometimes progressive, sometimes chaotic, but always fascinating place.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0